import { render, staticRenderFns } from "./BaseFrontOfficeSubtitle.vue?vue&type=template&id=4cdfa77f&scoped=true"
import script from "./BaseFrontOfficeSubtitle.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeSubtitle.vue?vue&type=script&lang=js"
import style0 from "./BaseFrontOfficeSubtitle.vue?vue&type=style&index=0&id=4cdfa77f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdfa77f",
  null
  
)

export default component.exports